const truthyValues = new Set(["1", "true", "yes", "да", "y"]);

const normalizeText = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/[\s_-]+/g, " ");

const parseTruthy = (value: unknown) => {
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    return truthyValues.has(normalizeText(value));
  }
  return false;
};

export const isTransitWarehouseName = (value: unknown) => {
  const normalized = normalizeText(value);
  if (!normalized) return false;

  return (
    normalized.includes("в пути") ||
    normalized.includes("впути") ||
    normalized.includes("in transit") ||
    normalized.includes("transit") ||
    normalized.includes("on way")
  );
};

export const isTransitWarehouse = (warehouse: unknown) => {
  if (!warehouse || typeof warehouse !== "object") {
    return isTransitWarehouseName(warehouse);
  }

  const record = warehouse as Record<string, unknown>;
  const explicitFlag =
    record.inTransit ??
    record.isTransit ??
    record.transit ??
    record.onWay ??
    record.on_way ??
    record.in_transit ??
    record["ВПути"] ??
    record["В пути"] ??
    record["СкладВПути"] ??
    record["СкладВпути"] ??
    record["Транзит"];

  if (parseTruthy(explicitFlag)) return true;

  return [
    record.name,
    record.label,
    record.warehouseName,
    record.address,
    record["НаименованиеСклада"],
    record["АдресСклада"],
    record["Наименование"],
    record["Адрес"],
  ].some(isTransitWarehouseName);
};
